import { render, staticRenderFns } from "./SiteList.vue?vue&type=template&id=13c7a132&scoped=true"
import script from "./SiteList.vue?vue&type=script&lang=js"
export * from "./SiteList.vue?vue&type=script&lang=js"
import style0 from "./SiteList.vue?vue&type=style&index=0&id=13c7a132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c7a132",
  null
  
)

export default component.exports